import React from 'react'

import { IUser } from 'types'

const UserContext = React.createContext<null | IUser>(null)

export default UserContext
